import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { setApolloState } from '../../lib/ApolloSchema/apolloUtils';
import { AppMode } from '@chegg/dropin-payments';
import { ADD_ITEM_FAILED, PLACE_ORDER_FAILED, PAYMENT_ERROR_ON_REVIEW, CustomCommandNames, REPLACE_ITEM_FAILED } from './constants';
import { CallbackTypes, Component, SuccessText, Namespace, ValidationManager, DropInPaymentsCommandNames, StatusTypes, UserActions, SharedCommandNames, fireLogEvent, fireStatusUpdate } from '@chegg/commerce-utils';
import { DIP_CALLBACK_CONTEXT, PM_INLINE_ERROR_CODE } from './constants';
import { sendNewRelicError } from '../../utils/NewRelicUtils';
import { reactiveCartData, reactiveAltProductData } from '../../lib/ApolloSchema/reactiveVars';
import { GENERIC_ERROR_MESSAGE } from '../../constants/appConstants';
import { getUniqueIDLookUp } from '../../utils/TransformUtils';
var INITIALIZE = SharedCommandNames.INITIALIZE;
var REVIEW_VIEW = DropInPaymentsCommandNames.REVIEW_VIEW,
  HISTORY_BACK_CLICK = DropInPaymentsCommandNames.HISTORY_BACK_CLICK,
  PLACE_ORDER = DropInPaymentsCommandNames.PLACE_ORDER,
  REMOVE_COUPON = DropInPaymentsCommandNames.REMOVE_COUPON,
  ADD_COUPON = DropInPaymentsCommandNames.ADD_COUPON,
  ADD_ITEM = DropInPaymentsCommandNames.ADD_ITEM,
  REPLACE_ITEM = DropInPaymentsCommandNames.REPLACE_ITEM;
var APP_MODE_CHANGED = CustomCommandNames.APP_MODE_CHANGED,
  MOP_SELECTED = CustomCommandNames.MOP_SELECTED;
var ADD = AppMode.ADD,
  DEFAULT_MOP = AppMode.DEFAULT_MOP,
  EDIT = AppMode.EDIT,
  LIST_MOPS = AppMode.LIST_MOPS,
  REVIEW_MOP = AppMode.REVIEW_MOP,
  YIFTEE_FULL_COVERAGE = AppMode.YIFTEE_FULL_COVERAGE;
/**
 * Returns a callback with which handles DropInPayments events (status updates and log events).
 */
export var getDipCallback = function getDipCallback(externalId, userAction, uiData) {
  return function (response) {
    var callbackType = response.callbackType,
      data = response.data;
    if (isStatusUpdate(callbackType, data)) {
      consumeStatusUpdates({
        data: data,
        externalId: externalId,
        userAction: userAction,
        uiData: uiData
      });
    } else {
      fireLogEvent(data, Namespace.ONE_CLICK);
    }
  };
};

/**
 * Handles DropInPayments status updates, such as succesfully placed orders, coupons added, etc
 */
function consumeStatusUpdates(params) {
  var statusUpdates = params.data,
    externalId = params.externalId,
    userAction = params.userAction,
    uiData = params.uiData;
  var uniqueIdLookup = getUniqueIDLookUp(uiData === null || uiData === void 0 ? void 0 : uiData.paymentErrors);
  var paymentErrorMessage;
  var _iterator = _createForOfIteratorHelper(statusUpdates),
    _step;
  try {
    var _loop = function _loop() {
      var _updateHandlerMap2;
      var statusUpdate = _step.value;
      var command = statusUpdate.command,
        status = statusUpdate.status,
        payload = statusUpdate.payload;
      var handleInitializeUpdate = function handleInitializeUpdate() {
        if (statusUpdate.status === StatusTypes.ERROR) {
          setApolloState({
            uiData: {
              showInitializeError: true
            }
          });
        }
      };
      var handleReviewBackUpdate = function handleReviewBackUpdate() {
        if (statusUpdate.status === StatusTypes.SUCCESS) {
          fireStatusUpdate([{
            status: StatusTypes.SUCCESS,
            command: DropInPaymentsCommandNames.REVIEW_VIEW,
            payload: {
              component: Component.CART_CHECKOUT,
              context: DIP_CALLBACK_CONTEXT
            }
          }], Namespace.ONE_CLICK);
        } else if (statusUpdate.status === StatusTypes.ERROR) {
          var _payload$errors, _payload$errors$0$mes, _payload$errors2;
          var errorCode = (_payload$errors = payload.errors) === null || _payload$errors === void 0 || (_payload$errors = _payload$errors[0]) === null || _payload$errors === void 0 ? void 0 : _payload$errors.code;
          paymentErrorMessage = uniqueIdLookup.getValue(errorCode);
          var serverErrorString = (_payload$errors$0$mes = (_payload$errors2 = payload.errors) === null || _payload$errors2 === void 0 ? void 0 : _payload$errors2[0].message) !== null && _payload$errors$0$mes !== void 0 ? _payload$errors$0$mes : GENERIC_ERROR_MESSAGE;

          // get error msg from mapping checkout-components/packages/InternalTools/src/constants/ServerErrors.ts
          // if no errObj found, use the message coming from the server.
          var errObj = errorCode ? ValidationManager.ValidationMessages.getMopError(errorCode) : undefined;
          var errorMessage = paymentErrorMessage || (errObj ? errObj.message_detail : serverErrorString);
          setApolloState({
            uiData: {
              errorMessage: errorMessage,
              isCTADisabled: false,
              isCTALoading: false
            }
          });
          fireStatusUpdate([{
            command: DropInPaymentsCommandNames.REVIEW_VIEW,
            status: StatusTypes.ERROR,
            payload: {
              component: Component.CART_CHECKOUT,
              context: DIP_CALLBACK_CONTEXT,
              errors: payload.errors
            }
          }], Namespace.ONE_CLICK);
          sendNewRelicError(PAYMENT_ERROR_ON_REVIEW, {
            errors: JSON.stringify(payload.errors),
            externalId: externalId
          });
        }
      };
      var handleHistoryBackUpdate = function handleHistoryBackUpdate() {
        setApolloState({
          reviewData: {
            currentStep: 1
          }
        });
      };
      var handleAddItemUpdate = function handleAddItemUpdate() {
        if (status === StatusTypes.SUCCESS) {
          var _ref = statusUpdate.payload.data,
            orderSummary = _ref.orderSummary;
          var orderGiftCodeBalance = orderSummary.orderGiftCodeBalance,
            totalWithCurrencyFormat = orderSummary.totalWithCurrencyFormat,
            discount = orderSummary.discount;
          setApolloState({
            orderData: {
              yiftee: orderGiftCodeBalance > 0
            },
            uiData: {
              errorMessage: '',
              isLoaded: true,
              isCTADisabled: false,
              isCTALoading: false
            }
          });
          var hasDiscount = orderGiftCodeBalance > 0 || discount;
          var discountedPriceReactive = hasDiscount && totalWithCurrencyFormat || undefined;
          var altProductData = reactiveAltProductData();
          if (altProductData.altItemData.length > 0) {
            // in upsell flow, we initially add alt product to cart in order to get discounted price
            reactiveAltProductData(_objectSpread(_objectSpread({}, altProductData), {}, {
              altDiscountedPrice: discountedPriceReactive,
              isAltDiscountedPriceFetched: true
            }));
            setApolloState({
              uiData: {
                isLoaded: false // persist loading state until CS discounted prices are fetched
              }
            });
          } else {
            reactiveCartData({
              discountedPrice: discountedPriceReactive
            });
            setApolloState({
              uiData: {
                isLoaded: true
              }
            });
          }
          fireStatusUpdate([{
            status: StatusTypes.SUCCESS,
            command: DropInPaymentsCommandNames.ADD_ITEM,
            payload: {
              component: Component.CART_CHECKOUT,
              context: DIP_CALLBACK_CONTEXT
            }
          }], Namespace.ONE_CLICK);
        } else if (status === StatusTypes.ERROR) {
          var _errors$;
          var errors = payload.errors;
          var errorCode = errors === null || errors === void 0 || (_errors$ = errors[0]) === null || _errors$ === void 0 ? void 0 : _errors$.code;
          paymentErrorMessage = uniqueIdLookup.getValue(errorCode);
          setApolloState({
            uiData: {
              errorMessage: paymentErrorMessage || GENERIC_ERROR_MESSAGE,
              isLoaded: true,
              isCTADisabled: false,
              isCTALoading: false
            }
          });
          fireStatusUpdate([{
            command: DropInPaymentsCommandNames.ADD_ITEM,
            status: StatusTypes.ERROR,
            payload: {
              component: Component.CART_CHECKOUT,
              context: DIP_CALLBACK_CONTEXT,
              errors: errors
            }
          }], Namespace.ONE_CLICK);
          sendNewRelicError(ADD_ITEM_FAILED, {
            errors: JSON.stringify(errors),
            externalId: externalId
          });
        }
      };
      var handlePlaceOrderUpdate = function handlePlaceOrderUpdate() {
        if (status === StatusTypes.SUCCESS) {
          var data = statusUpdate.payload.data;
          var _ref2 = data,
            token = _ref2.token,
            cartId = _ref2.cartId;
          setApolloState({
            orderData: {
              token: token,
              cartId: cartId
            }
          });
          sendNewRelicError(getSuccessMessage(userAction), {
            externalId: externalId
          });
        } else if (status === StatusTypes.PENDING) {
          setApolloState({
            uiData: {
              errorMessage: '',
              isCTADisabled: true,
              isCTALoading: true
            }
          });
          fireStatusUpdate([{
            command: DropInPaymentsCommandNames.PLACE_ORDER,
            status: StatusTypes.PENDING,
            payload: {
              component: Component.CART_CHECKOUT,
              context: DIP_CALLBACK_CONTEXT
            }
          }], Namespace.ONE_CLICK);
        } else if (status === StatusTypes.ERROR) {
          var _payload$errors3, _payload$errors$0$mes2, _payload$errors4;
          var errorCode = (_payload$errors3 = payload.errors) === null || _payload$errors3 === void 0 || (_payload$errors3 = _payload$errors3[0]) === null || _payload$errors3 === void 0 ? void 0 : _payload$errors3.code;
          paymentErrorMessage = uniqueIdLookup.getValue(errorCode);
          var serverErrorString = (_payload$errors$0$mes2 = (_payload$errors4 = payload.errors) === null || _payload$errors4 === void 0 ? void 0 : _payload$errors4[0].message) !== null && _payload$errors$0$mes2 !== void 0 ? _payload$errors$0$mes2 : GENERIC_ERROR_MESSAGE;

          // get error msg from mapping checkout-components/packages/InternalTools/src/constants/ServerErrors.ts
          // if no errObj found, use the message coming fromt the server.

          var errObj = errorCode ? ValidationManager.ValidationMessages.getMopError(errorCode) : undefined;
          var errorMessage = paymentErrorMessage || (errObj ? errObj.message_detail : serverErrorString);
          setApolloState({
            uiData: {
              errorMessage: errorMessage,
              isCTADisabled: false,
              isCTALoading: false
            }
          });
          fireStatusUpdate([{
            command: DropInPaymentsCommandNames.PLACE_ORDER,
            status: StatusTypes.ERROR,
            payload: {
              component: Component.CART_CHECKOUT,
              context: DIP_CALLBACK_CONTEXT,
              errors: payload.errors
            }
          }], Namespace.ONE_CLICK);
          errorCode !== PM_INLINE_ERROR_CODE && sendNewRelicError(PLACE_ORDER_FAILED, {
            errors: JSON.stringify(payload.errors),
            externalId: externalId
          });
        }
      };
      var handleAppModeChangedUpdate = function handleAppModeChangedUpdate() {
        //@ts-ignore
        // eslint-disable-next-line no-case-declarations
        var appMode = payload.data.appMode;
        handleAppModeChange(appMode, uiData);
      };
      var handleMopSelectedUpdate = function handleMopSelectedUpdate() {
        var isNewUserNoMop = userAction === UserActions.JOIN && !payload.data;
        setApolloState({
          uiData: {
            errorMessage: '',
            newUserNoMop: isNewUserNoMop
          }
        });
      };
      var handleAddCouponUpdate = function handleAddCouponUpdate() {
        if (statusUpdate.status === StatusTypes.SUCCESS) {
          var _payload$data;
          reactiveCartData(_objectSpread(_objectSpread({}, reactiveCartData()), {}, {
            discountedPrice: statusUpdate.payload.data.orderSummary.totalWithCurrencyFormat
          }));
          fireStatusUpdate([{
            status: StatusTypes.SUCCESS,
            command: DropInPaymentsCommandNames.ADD_COUPON,
            payload: {
              component: Component.CART_CHECKOUT,
              context: DIP_CALLBACK_CONTEXT,
              data: {
                couponCode: (_payload$data = payload.data) === null || _payload$data === void 0 ? void 0 : _payload$data.couponCode
              }
            }
          }], Namespace.ONE_CLICK);
        }
      };
      var handleRemoveCouponUpdate = function handleRemoveCouponUpdate() {
        if (statusUpdate.status === StatusTypes.SUCCESS) {
          reactiveCartData(_objectSpread(_objectSpread({}, reactiveCartData()), {}, {
            discountedPrice: undefined
          }));
          fireStatusUpdate([{
            status: StatusTypes.SUCCESS,
            command: DropInPaymentsCommandNames.REMOVE_COUPON,
            payload: {
              component: Component.CART_CHECKOUT,
              context: DIP_CALLBACK_CONTEXT
            }
          }], Namespace.ONE_CLICK);
        }
      };
      var handleReplaceItemUpdate = function handleReplaceItemUpdate() {
        if (status === StatusTypes.SUCCESS) {
          var _ref3 = statusUpdate.payload.data,
            orderSummary = _ref3.orderSummary;
          var orderGiftCodeBalance = orderSummary.orderGiftCodeBalance,
            totalWithCurrencyFormat = orderSummary.totalWithCurrencyFormat,
            discount = orderSummary.discount;
          setApolloState({
            orderData: {
              yiftee: orderGiftCodeBalance > 0
            },
            uiData: {
              errorMessage: '',
              isLoaded: true,
              isCTADisabled: false,
              isCTALoading: false
            }
          });
          var existingDiscountedPrice = reactiveCartData().discountedPrice;
          if (totalWithCurrencyFormat && (orderGiftCodeBalance > 0 || discount) && !existingDiscountedPrice) {
            reactiveCartData({
              discountedPrice: totalWithCurrencyFormat
            });
          }
          fireStatusUpdate([{
            status: StatusTypes.SUCCESS,
            command: DropInPaymentsCommandNames.REPLACE_ITEM,
            payload: {
              component: Component.CART_CHECKOUT,
              context: DIP_CALLBACK_CONTEXT
            }
          }], Namespace.ONE_CLICK);
        } else if (status === StatusTypes.ERROR) {
          var _errors$2;
          var errors = payload.errors;
          var errorCode = errors === null || errors === void 0 || (_errors$2 = errors[0]) === null || _errors$2 === void 0 ? void 0 : _errors$2.code;
          paymentErrorMessage = uniqueIdLookup.getValue(errorCode);
          setApolloState({
            uiData: {
              errorMessage: paymentErrorMessage || GENERIC_ERROR_MESSAGE,
              isLoaded: true,
              isCTADisabled: false,
              isCTALoading: false
            }
          });
          fireStatusUpdate([{
            command: DropInPaymentsCommandNames.REPLACE_ITEM,
            status: StatusTypes.ERROR,
            payload: {
              component: Component.CART_CHECKOUT,
              context: DIP_CALLBACK_CONTEXT,
              errors: errors
            }
          }], Namespace.ONE_CLICK);
          sendNewRelicError(REPLACE_ITEM_FAILED, {
            errors: JSON.stringify(errors),
            externalId: externalId
          });
        }
      };
      var updateHandlerMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, INITIALIZE, handleInitializeUpdate), REVIEW_VIEW, handleReviewBackUpdate), HISTORY_BACK_CLICK, handleHistoryBackUpdate), ADD_ITEM, handleAddItemUpdate), PLACE_ORDER, handlePlaceOrderUpdate), APP_MODE_CHANGED, handleAppModeChangedUpdate), MOP_SELECTED, handleMopSelectedUpdate), ADD_COUPON, handleAddCouponUpdate), REMOVE_COUPON, handleRemoveCouponUpdate), REPLACE_ITEM, handleReplaceItemUpdate);

      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      (_updateHandlerMap2 = updateHandlerMap[command || '']) === null || _updateHandlerMap2 === void 0 || _updateHandlerMap2.call(updateHandlerMap);
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

/**
 * Type predicate function which narrows a DropInPayments callback type to either a status update or a log event.
 */
export function isStatusUpdate(callbackType, data) {
  return callbackType === CallbackTypes.STATUS_UPDATE;
}

/**
 * Sets Apollo states corresponding to app UI modes
 */
export var handleAppModeChange = function handleAppModeChange(appMode, uiData) {
  var _modeChangeHandlerMap2;
  var handleAddMode = function handleAddMode() {
    setApolloState({
      uiData: {
        showOnlyPM: !(uiData !== null && uiData !== void 0 && uiData.newUserNoMop),
        cardActionMode: 'Add',
        errorMessage: ''
      }
    });
  };
  var handleEditMode = function handleEditMode() {
    setApolloState({
      uiData: {
        showOnlyPM: !(uiData !== null && uiData !== void 0 && uiData.newUserNoMop),
        cardActionMode: 'Edit',
        errorMessage: ''
      },
      reviewData: {
        currentStep: 1
      }
    });
  };
  var handleReviewMode = function handleReviewMode() {
    setApolloState({
      uiData: {
        showOnlyPM: false,
        cardActionMode: 'None',
        errorMessage: '',
        isCTADisabled: false,
        isCTALoading: false
      },
      reviewData: {
        currentStep: 2
      }
    });
  };
  var defaultModeHandler = function defaultModeHandler() {
    setApolloState({
      uiData: {
        showOnlyPM: false,
        cardActionMode: 'None',
        errorMessage: ''
      }
    });
    setApolloState({
      reviewData: {
        currentStep: 1
      }
    });
  };
  var modeChangeHandlerMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ADD, handleAddMode), EDIT, handleEditMode), DEFAULT_MOP, defaultModeHandler), REVIEW_MOP, handleReviewMode), LIST_MOPS, defaultModeHandler), YIFTEE_FULL_COVERAGE, defaultModeHandler);

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  (_modeChangeHandlerMap2 = modeChangeHandlerMap[appMode]) === null || _modeChangeHandlerMap2 === void 0 || _modeChangeHandlerMap2.call(modeChangeHandlerMap);
};

/**
 * Maps actions (join, upgrade, subscribe) to their corresponding success messages.
 */
export var getSuccessMessage = function getSuccessMessage(action) {
  var actionTextMap = _defineProperty(_defineProperty(_defineProperty({}, UserActions.JOIN, SuccessText.SUBSCRIPTION_SUBSCRIBED), UserActions.UPGRADE, SuccessText.SUBSCRIPTION_UPGRADED), UserActions.RESUBSCRIBE, SuccessText.SUBSCRIPTION_RESUBSCRIBED);
  var isHandledAction = action === UserActions.JOIN || action === UserActions.UPGRADE || action === UserActions.RESUBSCRIBE;
  return isHandledAction ? actionTextMap[action] : SuccessText.SUBSCRIPTION_RESUBSCRIBED;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/modules/DropInPayments/helpers.js
// module id = 4706
// module chunks = 11